import { GroupQuery } from './group.query';
import { GroupService } from './group.service';
import { GroupStore } from './group.store';

export * from './group.model';
export * from './group.query';
export * from './group.service';
export * from './group.store';

export default [GroupStore, GroupQuery, GroupService];
